import useBaseApiHook, { BASE_API_CONSTANT } from 'services/useBaseApiHook'

const useRoleAccessRepo = (initialLoading = false) => {
  const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

  const getRoleAccessByRoleProfile = async (roleId, profileId) => {
    return await executeApi(`/role-access/get-by-role-profile?roleId=${roleId}&profileTypeId=${profileId}`, BASE_API_CONSTANT.METHOD.GET)
  }

  return {
    isLoading,
    data,
    error,
    getRoleAccessByRoleProfile
  }
}

export default useRoleAccessRepo
